import React from 'react';

interface IFlexibleBiddingIconProps {
  height?: number;
  width?: number;
}
export function DoNotUseDemandSourceSettingsIcon({
  height = 16,
  width = 16,
}: IFlexibleBiddingIconProps) {
  return <img src='/assets/shared/svg/UseSpotxTierIcon.svg' height={height} width={width} />;
}
